export const endpoints = {
  getFamilyGroupAdminView: () => 'api/product/FamilyGroups?$count=true',
  getFamilyGroupMasterData: () => 'api/familygroup/Familygroups',
  getFamilyGroupData: () => 'api/familygroup/Familygroups?$count=true',
  getProductData: (count: boolean = true) => count ? 'api/product/Products?$count=true' : 'api/product/Products?',
  getProductById: (id: string) => `api/product/Products/${id}`,
  getVolumetricsReviewData: () => `/api/product/VolumetricsReviews?$count=true`,
  getVolumetricsReviewDataById: (id: string) => `/api/product/VolumetricsReviews?$count=false&$filter=Id eq '${id}'`,
  searchProductData: () => `api/product/Products/search`,
  searchProductIndex: () => `api/product/Products/searchProductsIndex`,
  updateFamilyGroupAdmin: () => 'api/product/FamilyGroups/UpdateMultipleProducts',
  updateFamilyGroup: (id: string) => `api/familygroup/FamilyGroups/${id}`,
  updateProduct: (id: string) => `api/product/Products/${id}`,
  updateVolumetricsReviewData: () => `api/product/Volumetrics/ProcessRow`,
  familyGroup: () => `api/familygroup/FamilyGroups`,
  missingFamilyGroup: () => `api/familygroup/FamilyGroups`,
  deleteFamilyGroup: (Id: string) => `api/familygroup/FamilyGroups/${Id}`,

  //File Upload endpoints Start
  uploadHistorys: () => 'api/fileupload/UploadHistorys',
  uploadHistorysById: (fileId: string) => `api/fileupload/downlaod/${fileId}`,
  uploadProduct: () => `api/fileupload/Uploads/Product`,
  uploadFamilyGroup: () => `api/fileupload/Uploads/FamilyGroup`,
  uploadVolumetricsReviewFile: () => `api/product/Volumetrics/ProcessFile`,

  //File Download endpoints
  downloadFamilyGroup: () => `api/Product/ExtractFamilyGroups`,
  downloadProduct: () => `api/Product/ExtractProducts`,
  downloadVolumetricsReviewFile: () => `api/product/VolumetricsReviews/DownloadExcel`,

   // LDM Scan App Endpoint
   downloadLDMApp: () => `api/v1/cubiscanupdate/download`,

  //Container Type maintenance
  getDuType: () => `api/dutypemaintenance/DuTypeMaintenances`,
  createDuTpe: () => `api/dutypemaintenance/DuTypeMaintenances`,
  getDuTypePaginated: () => `api/dutypemaintenance/DuTypeMaintenances?$count=true&OrderBy=createdDate desc`,
  getDuTypeByIdx: (Id: string) => `api/dutypemaintenance/DuTypeMaintenances/${Id}`,
  updateDuTypeByIdx: (Id: string) => `api/dutypemaintenance/DuTypeMaintenances/${Id}`,
  deleteDuType: (Id: string) => `api/dutypemaintenance/DuTypeMaintenances/${Id}`,

  getResult: (path: string) => `api/${path}`,
}